import { Component, OnInit } from '@angular/core';
import { RepositoryService } from './../../shared/services/repository.service'
import { MitigatingAction } from "../../_interfaces/MitigatingAction.model";
import { RiskEvent } from "../../_interfaces/RiskEvent.model";

@Component({
  selector: 'app-my-mitigating-action-list',
  templateUrl: './my-mitigating-action-list.component.html',
  styleUrls: ['./my-mitigating-action-list.component.css']
})
export class MyMitigatingActionListComponent implements OnInit {

  public mitigatingActions: MitigatingAction[];

  constructor(private repository: RepositoryService)   { }

    ngOnInit() {
      this.getAllMitigations();
    }

  public getAllMitigations() {
      let apiAddress: string = `MitigatingActions`;
    this.repository.getData(apiAddress)
      .subscribe(res => {
          this.mitigatingActions = res as MitigatingAction[];
      });
  }

  public getPendingMitigations() {
    let apiAddress: string = `MitigatingActions?status=notified`;
    this.repository.getData(apiAddress)
      .subscribe(res => {
        this.mitigatingActions = res as MitigatingAction[];
      });
  }

  public getOverdueMitigations() {
    let apiAddress: string = `MitigatingActions?status=overdue`;
    this.repository.getData(apiAddress)
      .subscribe(res => {
        this.mitigatingActions = res as MitigatingAction[];
      });
  }


    public addMitigatingAction() {
      // Only do this from Risk Record

    }

}
